import { Controller } from "@hotwired/stimulus";
import intlTelInput from "intl-tel-input";

export default class extends Controller {
  static targets = ["input"];

  connect() {
    const input = this.inputTarget;
    intlTelInput(input, {
      utilsScript:
        "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.13/js/utils.min.js",
      hiddenInput: "phone",
      initialCountry: "us",
      preferredCountries: ["us"],
      separateDialCode: true,
      customContainer: "w-full",
    });
  }
}
